import { render, staticRenderFns } from "./ElitePlayerAuthAlert.vue?vue&type=template&id=6def459d&scoped=true&"
import script from "./ElitePlayerAuthAlert.vue?vue&type=script&lang=js&"
export * from "./ElitePlayerAuthAlert.vue?vue&type=script&lang=js&"
import style0 from "./ElitePlayerAuthAlert.vue?vue&type=style&index=0&id=6def459d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def459d",
  null
  
)

export default component.exports